import PopoverComponent from './PopoverComponent';

export default PopoverComponent;



// WEBPACK FOOTER //
// ./~/rp-react-common/PopoverComponent/index.js